import normalizeWhitespace from "./normalizeWhitespace";
export default function getNormalizedCountLabel({ value, maxLength }) {
    if (!maxLength) {
        return undefined;
    }
    const fieldValue = typeof value === "string" ? value : "";
    return `${normalizeWhitespace(fieldValue).length}/${maxLength}`;
}
